import { createElementBlock as l, openBlock as n, normalizeClass as d, Fragment as x, createElementVNode as t, createCommentVNode as a, createBlock as m, toDisplayString as s, renderSlot as u, unref as r, createVNode as h } from "vue";
import { screenProp as k } from "../../utils/utilsScreen.js";
/* empty css                     */
import y from "../../_virtual/_plugin-vue_export-helper.js";
import g from "../../molecules/link/link.vue.js";
import w from "../../atoms/image-element/image-element.vue.js";
const v = { class: "ds-grid__col ds-grid__col--12 ds-md-grid__col--6" }, z = ["srcset"], S = ["srcset"], B = ["srcset"], N = ["src", "alt"], $ = { class: "ds-media-text-card__text ds-grid__col ds-grid__col--12 ds-md-grid__col--6 ds-lg-grid__col--5" }, C = { class: "ds-margin-top-24 ds-lg-margin-top-0" }, E = { class: "ds-heading" }, b = { class: "ds-text ds-height-full ds-margin-top-12" }, j = {
  key: 0,
  class: "ds-media-text-card__slot"
}, q = { class: "ds-media-text-card__text" }, I = { class: "ds-display-flex ds-flex-direction-column" }, O = {
  key: 0,
  class: "ds-media-text-card__slot"
}, o = "DsMediaTextCard", V = /* @__PURE__ */ Object.assign({
  name: o
}, {
  __name: "media-text-card",
  props: {
    ...k,
    left: {
      type: Boolean,
      default: !1
    },
    image: {
      type: Object,
      required: !0,
      validator: (e) => {
        const i = {
          sizes: ["small", "medium", "large"],
          fields: ["src", "name"]
        };
        return i.sizes.every((c) => c in e && i.fields.every((f) => f in e[c]));
      }
    },
    title: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      required: !0
    },
    fontSizeSmall: {
      type: Boolean,
      default: !1
    },
    link: {
      type: Object,
      default: null
    },
    contained: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (i, c) => (n(), l("div", {
      class: d(["ds-media-text-card ds-justify-content-space-between ds-align-items-center", [
        { "ds-grid": !e.contained },
        { "ds-md-grid--reverse": !e.left && !e.contained },
        { "ds-media-text-card--contained": e.contained }
      ]])
    }, [
      e.contained ? (n(), l("div", {
        key: 1,
        class: d(["ds-media-text-card__wrapper ds-display-flex", e.left ? "ds-flex-direction-row" : "ds-flex-direction-row-reverse"])
      }, [
        h(r(w), {
          image: e.image,
          screen: i.screen,
          class: "ds-media-text-card__image"
        }, null, 8, ["image", "screen"]),
        t("div", q, [
          t("div", I, [
            t("h2", {
              class: d(e.fontSizeSmall ? "ds-heading-small" : "ds-heading")
            }, s(e.title), 3),
            t("p", {
              class: d(["ds-height-full ds-margin-top-12", { "ds-text-small": e.fontSizeSmall }])
            }, s(e.text), 3),
            i.$slots.default ? (n(), l("div", O, [
              u(i.$slots, "default", {}, void 0, !0)
            ])) : a("", !0),
            e.link ? (n(), m(r(g), {
              key: 1,
              "tracking-data": { "component-name": o, text: e.link.title, title: e.title },
              url: e.link.url,
              "lazy-url-endpoint": e.link.lazyUrlEndpoint,
              "open-in-new-window": e.link.openInNewWindow,
              nuxt: e.link.nuxt,
              content: e.link.title,
              "icon-right": { category: "arrows", name: "chevron-right-small" },
              class: "ds-margin-top-24"
            }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "open-in-new-window", "nuxt", "content"])) : a("", !0)
          ])
        ])
      ], 2)) : (n(), l(x, { key: 0 }, [
        t("div", v, [
          t("picture", null, [
            t("source", {
              media: "(max-width: 767px)",
              srcset: e.image.small.src
            }, null, 8, z),
            t("source", {
              media: "(max-width: 1247px)",
              srcset: e.image.medium.src
            }, null, 8, S),
            t("source", {
              media: "(min-width: 1248px)",
              srcset: e.image.large.src
            }, null, 8, B),
            t("img", {
              class: "ds-media-text-card__image",
              src: e.image.small.src,
              alt: e.image.small.name
            }, null, 8, N)
          ])
        ]),
        t("div", $, [
          t("div", C, [
            t("h3", E, s(e.title), 1),
            t("p", b, s(e.text), 1),
            i.$slots.default ? (n(), l("div", j, [
              u(i.$slots, "default", {}, void 0, !0)
            ])) : a("", !0),
            e.link ? (n(), m(r(g), {
              key: 1,
              "tracking-data": { "component-name": o, text: e.link.title, title: e.title },
              url: e.link.url,
              "lazy-url-endpoint": e.link.lazyUrlEndpoint,
              "open-in-new-window": e.link.openInNewWindow,
              nuxt: e.link.nuxt,
              content: e.link.title,
              "icon-right": { category: "arrows", name: "chevron-right-small" },
              class: "ds-margin-top-24"
            }, null, 8, ["tracking-data", "url", "lazy-url-endpoint", "open-in-new-window", "nuxt", "content"])) : a("", !0)
          ])
        ])
      ], 64))
    ], 2));
  }
}), M = /* @__PURE__ */ y(V, [["__scopeId", "data-v-341e3637"]]);
export {
  M as default
};
